import React, {Component} from "react";
import OauthClientFactory from "./OauthClientFactory";
import {RequestAuthorizationCode} from "react-oauth2-auth-code-flow";
import PropTypes from "prop-types";
import accountWhite from '../components/header/img/account-white.png';
import account from '../components/header/img/account.png';
import {getLanguageFromUrl} from "../helpers/util";

export class SendToTnAccountContainer extends Component {

  constructor(props) {
    super(props)
    this.requestAuthorizationCodeLinkRef = React.createRef(null);
  }

  componentDidMount() {
    const shouldCallLogin = this.props.cookie ? this.props.cookie.shouldCallLogin : false;
    const isLoggingIn = window.location.href.includes('/session-oauth');
    if (shouldCallLogin && !isLoggingIn) {
      this.requestAuthorizationCodeLinkRef.current.click();
      this.props.setShouldCallLogin(false);
    }
  }

  render() {
    const client = OauthClientFactory.create();
    const language = getLanguageFromUrl();
    const labels = require(`../trans/${language}`)
    return (
      <RequestAuthorizationCode
        oauthClient={client}
        state={{from: this.props.from}}
        args={{scope: `user_info user_msisdn ftth_info`}}
        render={({url}) => <a ref={this.requestAuthorizationCodeLinkRef} href={url} className="no-underline">
        <span id="2" className={`list-item second-level yettel-light-font account-login ytl-mobile-menu-item`}>
          {this.props.isTextVisible ? labels.account : ""} <img className="icon" alt="signup"
                                                                src={this.props.isWhite ? accountWhite : account}/>
        </span></a>}
      />
    );
  }

}

SendToTnAccountContainer.propTypes = {
  from: PropTypes.string.isRequired,
  client: PropTypes.object.isRequired,
  isTextVisible: PropTypes.bool,
  isWhite: PropTypes.bool,
  setShouldCallLogin: PropTypes.func.isRequired
}

SendToTnAccountContainer.defaultProps = {
  isTextVisible: true,
  isWhite: true
}

export default SendToTnAccountContainer;
